import { Close } from '@mui/icons-material';
import { IconButtonProps } from '@mui/material/IconButton/IconButton';
import { IconButton } from '@mui/material';

interface RemoveProps extends IconButtonProps {}

export function Remove(props: RemoveProps) {
  return (
    <IconButton {...props}>
      <Close />
    </IconButton>
  );
}
